import {LoadingService, MessagesModal, MessageModalMessageList, RemoteExceptionHandler} from "front-end-web-commons/app/index.d.ts";
import {IHttpService} from "angular";
import {IScope} from "angular"
import {
    InstanceTypeByRemoteServicesConfigParams,
    RemoteRoutingService,
    ResourceData
} from "./remoteRoutingService";
import {remoteRoutingModule} from "./remoteRoutingModule";

const arrays = require("front-end-web-commons/app/arrays/arrays")

const delay = ms => new Promise(res => setTimeout(res, ms));

class NlgRemoteRoutingStatusController {
    private resources: ResourceData[];
    private hasOrchestratedResource: boolean;
    private currentStatus: string;
    private currentColor: string;
    private minInterval = 15*1000;
    private millisecondsToLoop: number;

    private colorsMaps = new Map([
        ["NONE", "#ed3030"],
        ["PROVISIONING", "#e1ee2f"],
        ["AVAILABLE", "#3eff12"]
    ]);
    private refresh: number;

    constructor(private $http: IHttpService,
                private remoteRoutingService: RemoteRoutingService,
                private $scope: IScope ) {
        this.millisecondsToLoop = this.minInterval;
        this.hasOrchestratedResource = false;
        this.refreshingData();

        const destroyListener = this.$scope.$on('$destroy', () => {
            this.cleanRefresh()
        });
    }

    private cleanRefresh(): void {
        window.clearTimeout(this.refresh)
    }

    getBundle(resource: ResourceData): string{
        return "orchestrated.resources." + resource.status;
    }

    loadData() {
        this.currentStatus = "NONE";
        this.remoteRoutingService.getRoutingAvailability().then((currentResources: ResourceData[]) => {
            this.resources = currentResources;
            this.currentStatus = "NONE";

            if(arrays.filter(this.resources, (resource) => {
                return "PROVISIONING" === resource.status;
            }).length != 0){
                this.currentStatus = "PROVISIONING";
            }

            if(arrays.filter(this.resources, (resource) => {
                return ['IDLE', 'RUNNING', 'RESERVED'].indexOf(resource.status) != -1;
            }).length != 0){
                this.currentStatus = "AVAILABLE";
            }
            this.currentColor = this.colorsMaps.get(this.currentStatus) ?? "#ed3030";
        }, ()=>{
            console.log("routing availability unreachable.");
        });
    }

    checkOrchestratedResource() {
        this.remoteRoutingService.getRemoteTypesConfigurations().then((types: InstanceTypeByRemoteServicesConfigParams[]) => {
            this.hasOrchestratedResource = types.length > 0;
        }, ()=>{
            console.log("remote types unreachable.");
        })
    }

    getCurrentColor(){
        return this.currentColor;
    }

    calculatemillisecondsToLoop(){
        if( this.resources && this.resources.length != 0 ){
            let lastusage:ResourceData = this.resources.reduce(function (p, v) {
                return ( p.lastUsage > v.lastUsage ? p : v );
            })

            let delta: number = 60*1000 - Math.abs(Date.now() - lastusage.lastUsage.valueOf());
            this.millisecondsToLoop = Math.max(delta, this.minInterval);
        }
    }

    refreshingData() {
        this.refresh = window.setTimeout(() => {
            window.clearTimeout(this.refresh);
            this.loadData();
            this.checkOrchestratedResource();
            this.calculatemillisecondsToLoop()
            this.refreshingData();
        }, this.millisecondsToLoop);
    }
}

remoteRoutingModule.directive("nlgRemoteRoutingStatus", [function () {
    return {
        restrict: "E",
        scope: {},
        controllerAs: "ctrl",
        controller: NlgRemoteRoutingStatusController,
        templateUrl: require("link!./nlgRemoteRoutingStatus.html"),
    }
}])